// src/components/intake/bodies/plaidSuggest.js
import { getPlaidSuggestions } from "../../../shared/_services/intake.services";
import { amountValue, formatAmount } from "../intakeRules";

// Fill only the lines the client has not typed into, and tick them; typed
// values always win (decision 22, R212): a differing suggestion for a typed
// line is kept as `offer` and shown beside it as "Use this". Nothing is saved
// until the primary.
export const filled = (draft, suggestions) => ({
  ...draft,
  lines: Object.fromEntries(
    Object.entries(draft.lines).map(([name, line]) => {
      const s = suggestions.find((x) => x.name === name);
      return [
        name,
        !s
          ? line
          : line.amount === ""
            ? { ticked: true, amount: formatAmount(s.amount) }
            : amountValue(line.amount) === amountValue(s.amount)
              ? line
              : { ...line, offer: formatAmount(s.amount) },
      ];
    }),
  ),
});

// True when `filled` would change the draft (a line filled or offered).
export const changes = (draft, suggestions) =>
  Object.entries(filled(draft, suggestions).lines).some(
    ([name, line]) => line !== draft.lines[name],
  );

// One suggestions read: { suggestions } or { error: true } (a failed read, or
// the server's `plaidError`).
export async function readSuggestions(pageKey) {
  try {
    const res = await getPlaidSuggestions(pageKey);
    if (res.data.plaidError) return { error: true };
    return { suggestions: res.data.suggestions };
  } catch (_) {
    return { error: true };
  }
}
